import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tabs, BorderGradient, Actions, Helper } from 'Components';
import './JobsDesktopSearchHeader.css';

const JobsDesktopSearchHeader = ({
  tabs,
  index,
  onTabsClick,
  showNoInformationFound,
  onSearchDownload,
}) => {
  const { t } = useTranslation();
  return (
    <div className="jobs-desktop-search-header">
      <div className="jobs-desktop-search-header__controls">
        {!showNoInformationFound ?
          <Helper text={t('tutorials:common.ExportToExcel')}>
            <Actions.ExportToExcel onClick={onSearchDownload} />
          </Helper>
          :
          <div />
        }
        <Helper text={t('tutorials:search.4')} placement="bottom-left">
          <Actions.ClearSearch to="jobs" />
        </Helper>

      </div>
      <BorderGradient />
      <div className="jobs-desktop-search-header__tabs">
        <Helper text={t('tutorials:searchResultsJobs.2')}>
          <Tabs
            tabs={tabs}
            labels={tabs.map(tab => t(`jobs:${tab}`))}
            index={index}
            onClick={onTabsClick}
            className="tabs__button jobs-desktop-search-header__tabs"
          />
        </Helper>
      </div>
    </div>
  );
};

JobsDesktopSearchHeader.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  index: PropTypes.number,
  onTabsClick: PropTypes.func,
  showNoInformationFound: PropTypes.bool,
  onSearchDownload: PropTypes.func,
};

export default JobsDesktopSearchHeader;



// WEBPACK FOOTER //
// ./src/containers/Jobs/JobsDesktop/JobsDesktopSearchHeader/JobsDesktopSearchHeader.jsx